import {
  DrawerHeader as ChakraDrawerHeader,
  ModalHeaderProps as ChakraModalHeaderProps,
  chakra,
  forwardRef,
  useModalStyles,
} from '@chakra-ui/react';
import React from 'react';

import { OmitChakraProps } from '../../utils/typeUtils';
import { useDrawerContext } from '../Drawer/Drawer';
import { DrawerCloseButton } from '../DrawerCloseButton/DrawerCloseButton';

export type DrawerHeaderProps = OmitChakraProps<ChakraModalHeaderProps>;

export const DrawerHeader = forwardRef<DrawerHeaderProps, 'header'>(
  ({ children, ...props }, ref) => {
    const styles = useModalStyles();
    const { isDismissable } = useDrawerContext();

    return (
      <ChakraDrawerHeader {...props} ref={ref}>
        <chakra.div __css={styles.headerContent}>{children}</chakra.div>
        {isDismissable && <DrawerCloseButton />}
      </ChakraDrawerHeader>
    );
  },
);
